import React from 'react';
import {
  DataTable, Typography, Box,
} from 'vindi-ds-components';
import token from 'vindi-ds-tokens';
import timeAgoInWords from '@utils/time_ago_in_words';

const event = {
  update: 'atualizou',
  create: 'criou',
  destroy: 'removeu',
};

const actionColumn = {
  headerName: <Typography variant='subtitle1'>Histórico</Typography>,
  field: 'action',
  width: 444,
  renderCell: ({ value }) => (value || <Typography variant='body2'>Não há histórico</Typography>),
};

const timeColumn = {
  headerName: ' ',
  field: 'time',
  width: 200,
};

function checkEmptyState(history) {
  return history.length !== 0 ? history : [{ id: 1 }];
}

function historicAction(user, action) {
  return (
    <Typography variant='body2' component='p'>{user} {event[action]} este produto</Typography>
  );
}

function Historic({ historic }) {
  const history = historic.map((h, index) => (
    {
      id: index,
      action: historicAction(h.user, h.action),
      time: timeAgoInWords(h.time),
    }
  ));

  const handlePage = () => new Promise((resolve) => {
    const data = {
      length: history.length,
      rows: checkEmptyState(history),
    };
    resolve(data);
  });

  const columns = [actionColumn, timeColumn];

  return (
    <Box mt={token.spacing.small.value}>
      <DataTable handlePages={() => handlePage()} options={{ paging: false }} columns={columns} />
    </Box>
  );
}

export default Historic;
